/**
 * A little helper to normalize string for search comparison, to make it easier
 * to find things. The value will be lower case and without spaces.
 *
 * @param {string} value
 */
const normalizeStringForSearch = (value) => value.toLowerCase().replace(" ", "").trim();
/**
 * Tries to convert any value to a string.
 *
 * @param {string} value
 */
const valueToString = (value) => {
    if (typeof value === "string") {
        return value.toString();
    }
    if (typeof value === "number") {
        return value.toString();
    }
    if (typeof value === "object") {
        return JSON.stringify(value);
    }
    return "";
};
/** Filter a list of select options using a search term. */
export const filterOptions = (options, searchTerm) => options.filter((option) => {
    if (!searchTerm) {
        return true;
    }
    // We gonna compare the entered search term against the search value of the option.
    // If there is no specific search value set we gonna use the value as a fallback.
    let target = option.searchValue || "";
    if (!target) {
        target += valueToString(option.value);
        if (typeof option.label === "string") {
            target += option.label;
        }
        else if (typeof option.label === "object" && "text" in option.label) {
            target += option.label.text || "";
        }
    }
    return normalizeStringForSearch(target).includes(normalizeStringForSearch(searchTerm));
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3B0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NlbGVjdC9oZWxwZXJzL29wdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTUE7Ozs7O0dBS0c7QUFDSCxNQUFNLHdCQUF3QixHQUFHLENBQUMsS0FBYSxFQUFVLEVBQUUsQ0FDekQsS0FBSyxDQUFDLFdBQVcsRUFBRSxDQUFDLE9BQU8sQ0FBQyxHQUFHLEVBQUUsRUFBRSxDQUFDLENBQUMsSUFBSSxFQUFFLENBQUM7QUFFOUM7Ozs7R0FJRztBQUNILE1BQU0sYUFBYSxHQUFHLENBQUMsS0FBVSxFQUFVLEVBQUU7SUFDM0MsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUM5QixPQUFPLEtBQUssQ0FBQyxRQUFRLEVBQUUsQ0FBQztJQUMxQixDQUFDO0lBRUQsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUM5QixPQUFPLEtBQUssQ0FBQyxRQUFRLEVBQUUsQ0FBQztJQUMxQixDQUFDO0lBRUQsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUM5QixPQUFPLElBQUksQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDL0IsQ0FBQztJQUVELE9BQU8sRUFBRSxDQUFDO0FBQ1osQ0FBQyxDQUFDO0FBRUYsMkRBQTJEO0FBQzNELE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxDQUMzQixPQUE0QixFQUM1QixVQUFtQixFQUNFLEVBQUUsQ0FDdkIsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDLE1BQU0sRUFBRSxFQUFFO0lBQ3hCLElBQUksQ0FBQyxVQUFVLEVBQUUsQ0FBQztRQUNoQixPQUFPLElBQUksQ0FBQztJQUNkLENBQUM7SUFFRCxtRkFBbUY7SUFDbkYsaUZBQWlGO0lBQ2pGLElBQUksTUFBTSxHQUFXLE1BQU0sQ0FBQyxXQUFXLElBQUksRUFBRSxDQUFDO0lBRTlDLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQztRQUNaLE1BQU0sSUFBSSxhQUFhLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBRXRDLElBQUksT0FBTyxNQUFNLENBQUMsS0FBSyxLQUFLLFFBQVEsRUFBRSxDQUFDO1lBQ3JDLE1BQU0sSUFBSSxNQUFNLENBQUMsS0FBSyxDQUFDO1FBQ3pCLENBQUM7YUFBTSxJQUFJLE9BQU8sTUFBTSxDQUFDLEtBQUssS0FBSyxRQUFRLElBQUksTUFBTSxJQUFJLE1BQU0sQ0FBQyxLQUFLLEVBQUUsQ0FBQztZQUN0RSxNQUFNLElBQUksTUFBTSxDQUFDLEtBQUssQ0FBQyxJQUFJLElBQUksRUFBRSxDQUFDO1FBQ3BDLENBQUM7SUFDSCxDQUFDO0lBRUQsT0FBTyx3QkFBd0IsQ0FBQyxNQUFNLENBQUMsQ0FBQyxRQUFRLENBQzlDLHdCQUF3QixDQUFDLFVBQVUsQ0FBQyxDQUNyQyxDQUFDO0FBQ0osQ0FBQyxDQUFDLENBQUMifQ==